import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { CHAPTER_ONE_PDF_URL } from "@/content";

export default function ChapterOnePage() {
  return (
    <>
      <SEO
        title="Chapter One — REGULATE by Tara Aurora"
        description="Read the opening of REGULATE — an introduction to the language your body has been speaking all along."
        noindex
      />

      <section data-testid="chapter-one-page" className="relative overflow-hidden grain border-b border-stone/60">
        <div
          aria-hidden="true"
          className="absolute -top-24 left-1/3 w-[36vw] max-w-[440px] aspect-square rounded-full bg-[radial-gradient(circle,rgba(76,144,128,0.08),transparent_65%)] blur-3xl anim-orb"
        />
        <div className="relative mx-auto max-w-3xl px-6 md:px-10 pt-40 md:pt-52 pb-24 md:pb-32">
          <Reveal>
            <p className="eyebrow mb-6 text-center">A Free Resource</p>
            <h1
              className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.08] text-center"
              data-testid="chapter-one-page-title"
            >
              Chapter One
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p
              className="mt-8 text-base md:text-lg leading-relaxed text-taupe max-w-xl mx-auto text-center"
              data-testid="chapter-one-page-subtitle"
            >
              The opening of REGULATE — an introduction to the language your
              body has been speaking all along.
            </p>
          </Reveal>

          <Reveal delay={0.25}>
            <div
              className="mt-14 md:mt-16 border border-stone bg-white/60 p-8 md:p-12 text-center"
              data-testid="chapter-one-download-panel"
            >
              <p className="font-serif italic text-xl md:text-2xl text-charcoal leading-relaxed">
                What Your Body Has Been Holding
              </p>
              <p className="mt-3 text-[11px] uppercase tracking-[0.3em] text-taupe">
                Chapter One · PDF
              </p>
              <a
                href={CHAPTER_ONE_PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="chapter-one-read-button"
                className="mt-8 inline-flex items-center gap-3 bg-teal text-white text-xs uppercase tracking-[0.25em] px-10 py-4 hover:bg-deepteal transition-colors duration-500"
              >
                Read Chapter One
                <ArrowRight size={14} />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.35}>
            <p
              className="mt-10 font-serif italic text-lg md:text-xl text-deepteal leading-relaxed text-center max-w-lg mx-auto"
              data-testid="chapter-one-page-instruction"
            >
              Read it slowly. There's no rush — it will meet you where you are.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
